const MutualFundsSection = () => {
  return (
    <section className="mutual-funds-section">
      <div className="container">
        <div className="mutual-funds-wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            <div className="col-lg-6">
              <div className="mutual-funds-image" data-aos="fade-right" data-aos-duration="800">
                <div className="image-container">
                  <img 
                    className="fund-image" 
                    src="assets/images/new/Mutual-Funds.webp" 
                    alt="Mutual Funds Investment" 
                  />
                  <div className="image-overlay"></div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mutual-funds-content" data-aos="fade-left" data-aos-duration="800">
                <div className="content-inner">
                  <h2 className="section-title">
                    Unlock the power of <span className="style2">mutual funds</span>
                  </h2>
                  <p className="tagline">
                    Invest in a wide array of mutual funds—equity, debt, hybrid, ETFs—with expert-selected portfolios, SIP options, and direct plans for cost-efficiency and diversification
                  </p>
                </div>
              </div>
            </div>
            
            <div className="col-lg-12 mt-5">
              <div className="mutual-funds-info" data-aos="fade-up" data-aos-duration="800">
                <div className="info-inner">
                  <h4 className="info-title">What are Mutual Funds, and How Do They Work?</h4>
                  <p className="info-text">
                    A mutual fund, an investment marvel, brings investors together under a shared goal.
                    Pooled money is expertly managed by professional fund managers, each fund organized around specific
                    investment objectives. At Signatureglobal Comtrade, we offer a diverse range of mutual fund
                    categories, including high return, tax-saving, top companies, and more.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="col-lg-12 mt-5">
              <div className="benefits-section" data-aos="fade-up" data-aos-duration="800">
                <div className="benefits-inner">
                  <h3 className="benefits-title">Why Should Mutual Funds Be Your Investment Choice?</h3>
                  
                  <div className="benefits-list">
                    <div className="benefit-item">
                      <div className="benefit-icon">✓</div>
                      <div className="benefit-content">
                        <h5 className="benefit-heading">Simplicity Redefined</h5>
                        <p className="benefit-text">
                          Invest effortlessly without the hassle of intensive research. Our
                          user-friendly platform guides you through the process.
                        </p>
                      </div>
                    </div>
                    
                    <div className="benefit-item">
                      <div className="benefit-icon">✓</div>
                      <div className="benefit-content">
                        <h5 className="benefit-heading">Diverse Portfolio Options</h5>
                        <p className="benefit-text">
                          Choose from our array of mutual fund categories, tailored to your
                          financial goals and risk tolerance.
                        </p>
                      </div>
                    </div>
                    
                    <div className="benefit-item">
                      <div className="benefit-icon">✓</div>
                      <div className="benefit-content">
                        <h5 className="benefit-heading">Expertise at Your Fingertips</h5>
                        <p className="benefit-text">
                          Benefit from professional management without the stress. Our
                          fund managers and research teams work tirelessly to optimize your investments.
                        </p>
                      </div>
                    </div>
                    
                    <div className="benefit-item">
                      <div className="benefit-icon">✓</div>
                      <div className="benefit-content">
                        <h5 className="benefit-heading">Tax-Efficient Solutions</h5>
                        <p className="benefit-text">
                          Maximize returns while minimizing tax implications. Our tax-saving
                          mutual fund options are designed to benefit your financial strategy.
                        </p>
                      </div>
                    </div>
                    
                    <div className="benefit-item">
                      <div className="benefit-icon">✓</div>
                      <div className="benefit-content">
                        <h5 className="benefit-heading">Risk Mitigation</h5>
                        <p className="benefit-text">
                          Spread your investments across a broad spectrum, reducing vulnerability to
                          market fluctuations. Transform your investment journey with mutual funds tailored to your aspirations.
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <p className="closing-statement">
                    At Signatureglobal Comtrade, we're not just your stockbrokers; we're your partners in prosperity.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};

export default MutualFundsSection;